// extracted by mini-css-extract-plugin
export default {"noMarginTop":"hHu9I"};